
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { Gift } from "lucide-react";

const CallToAction = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <section className="py-20 px-4 bg-gradient-to-r from-blue-600 via-purple-600 to-green-600">
      <div className="container mx-auto text-center">
        <div className="max-w-4xl mx-auto text-white">
          <h2 className="text-4xl md:text-6xl font-bold mb-6 !text-white">
            {t('callToAction.readyToTransform')}
            <span className="block">{t('callToAction.groceryShopping')}</span>
          </h2>

          <p className="text-xl md:text-2xl mb-8 opacity-90">
            {t('callToAction.joinThousandsOfFamilies')}
            <br />
            {t('callToAction.startYourJourneyToday')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <Button
              onClick={() => navigate('/login')}
              className="bg-white text-blue-600 hover:bg-gray-100 px-8 py-6 text-lg rounded-full shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
            >
              <Gift className="mr-2" size={20} />
              {t('callToAction.startFreeTrial')}
            </Button>

            {/* <Button
              variant="outline"
              onClick={() => navigate('/login')}
              className="border-2 border-white text-blue-600 hover:bg-gray-100 hover:text-gray-600 hover:shadow-xl px-8 py-6 text-lg rounded-full transition-all duration-300"
            >
              <ShoppingCart className="mr-2" size={20} />
              {t('callToAction.getStarted')}
            </Button> */}
          </div>

          <p className="text-sm opacity-75">
            {t('callToAction.noCreditCardRequired')} • {t('callToAction.worksOnAllDevices')} • {t('callToAction.cancelAnytime')}
          </p>
        </div>
      </div>
    </section>
  );
};

export default CallToAction;
